export default function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}


//////////////////
// WEBPACK FOOTER
// /Users/erikoberhausen/Documents/upperhouse/sukle/awkwardagent/awkward/web/app/themes/sage/node_modules/swiper/core/translate/maxTranslate.js
// module id = 410
// module chunks = 6